import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, ModalBody, ModalHeader, Row, Form} from "reactstrap";
import { decryptData } from "../../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { createApplicationActivity, updateTask } from "../../../api/Applications";
import { failed, success } from "../../../utils/Tostify";
import TextInput from "../../../components/InputFields/TextInput";
import DatePickerSelector from "../../../components/InputFields/DatePicker";
import moment from "moment";
import { taskActionOptions, formikTasks } from "../Constant";
import { getDocumentTypeList } from "../../../api/workflow";
import Loader from "../../../components/Loader/Loader";
import { ActivityDetails } from "../../../utils/constants";
import { getStaffsByOrgId } from "../../../api/User";

//This component is used in Application under Tasks tab
const AddTask = ({ isOpen, taskData, application, toggle, getApplication, AllTasks}) => {
  const isEdit = taskData?._id;
  const dispatch = useDispatch();
  let token = useSelector((state) => state.userReducer.token);
  const [isLoading, setIsLoading] = useState(false);
  const [documentList, setDocumentList] = useState(false);
  const [patientList, setPatientList] = useState([]);
  const [applicationList, setApplicationList] = useState([]);
  const [assignToList, setAssignToList] = useState([]);
  let user = useSelector((state) => state?.userReducer?.user);

  const formik = useFormik({
    ...formikTasks,
    onSubmit: async (values) => {
      let res;
      try {
        const payload = {tasks : {...values , editedBy: user?._id}  };
        setIsLoading(true);
        res = await updateTask({values:payload, dispatch, token, applicationId: application?._id, taskId: taskData?._id, createdBy: user?._id});
        const responseData = decryptData(res?.data);
        if (res?.status === "SUCCESS") {
          let values = {
            type : "Application",
            event : ActivityDetails?.TaskCreationUpdate?.event,
            applicationId : application?._id,
            clinicId: localStorage.getItem("currentHospitalId"),
            organizationId: localStorage.getItem("currentOrgId"),
            patientId : application?.patientData?._id ,
            details : isEdit ? "Task Updated" : "Task Created"
          };
          await createApplicationActivity({ values, dispatch, token });
          await getApplication();
          if (typeof AllTasks === "function") {
            await AllTasks();
          } else {
            // console.warn("AllTasks is not a function, skipping...");
          }
          enhancedToggle(false);
          setIsLoading(false);
          success(res?.message);
        }
      } catch (error) {
        failed(res?.message);
        setIsLoading(false);
      }
    }
  });

  const getDocumentList = async (page, limit, searchKey = "") => {
    let res;
    try {
        res = await getDocumentTypeList({dispatch, token, page, limit, searchKey});
        const responseData = decryptData(res?.data);
        if (res?.status === "SUCCESS") {
          const dropList = responseData?.items?.map((doc) => ({
            label: doc.documentTitle,
            value: doc._id
          })) || [];
            setDocumentList(dropList);
        }else{
          setIsLoading(false);
          failed(res?.message);
        }
    } catch (error) {
        failed(res?.message);
        setIsLoading(false);
    }
  };

  useEffect(()=>{
    getDocumentList();
    getStaffList();
  },[]);

  const [staffList, setStaffList] = useState([]);

  const getStaffList = async (page, limit, searchKey = "") => {
    let res;
    try {
      res = await getStaffsByOrgId({dispatch, token, page, limit, searchKey, orgId: localStorage.getItem("currentOrgId"), currentHospitalId : localStorage.getItem("currentHospitalId"), dataLimit: "all"});
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        const dropdownData = responseData?.items?.map((staff) => ({
          label: `${staff.firstName} ${staff.lastName}`,
          value: staff._id
        }));
        setStaffList(dropdownData);
      }
    } catch (error) {
      failed(res?.message);
    }
  };

  useEffect(() => {
    if (application) {
      const dropPatientList = {
        label: decryptData(application?.patientData?.name[0].text),
        value: application?.patientData?._id
      };
      setPatientList([dropPatientList]);

      // Set assignToList using staffList instead of application.consultantUser
      const assignToList = staffList.map(staff => ({
        label: staff.label,
        value: staff.value
      }));

      setAssignToList([...assignToList, dropPatientList]);

      const applicationList = [{
        label: application?.title,
        value: application?._id
      }];
      setApplicationList(applicationList);
    }
  }, [application, staffList]); // Added staffList as a dependency

  const enhancedToggle = () => {
    toggle();
    formik.resetForm();
  };

  useEffect(() => {
    if (taskData) {
      formik.setValues({
        patientId: taskData?.patientId ? taskData?.patientId : null,
        assignTo: taskData?.assignTo ? taskData?.assignTo : null,
        applicationId: taskData?.applicationId ? taskData?.applicationId : null,
        dueDate: taskData?.dueDate ? taskData?.dueDate : null,
        title: taskData?.title ? taskData?.title : "",
        taskAction: taskData?.taskAction ? taskData?.taskAction : null,
        documentId: taskData?.documentId ? taskData?.documentId : null,
        formId: taskData?.formId ? taskData?.formId : null,
        notes: taskData?.notes ? taskData?.notes : null
      });
    }
  }, [taskData]);

  const isDocumentListVisible = formik.values.taskAction === "Upload Document";
  const isFormListVisible = ["Update Form", "Sign Form", "Verify Form"].includes(formik.values.taskAction);

  // Define different form options based on selected Task Action
const VerifyformOptions = application?.applicationForms?.map((app) => ({
  label: app.formTitle,
  value: app._id
})) || [];

const UpdateformOptions = application?.applicationForms
  ?.filter((app) => ["To Do", "InProgress"].includes(app.status?.trim())) // Filter by status
  ?.map((app) => ({
    label: app.formTitle,
    value: app._id
  })) || [];

  const UpdateDocumentOptions = application?.applicationDocuments
    ?.map((app) => ({
      label: app.title,
      value: app.documentId
    })) || [];

  // Select the appropriate form options dynamically
const selectedFormOptions =
formik.values.taskAction === "Verify Form"
  ? VerifyformOptions
  : formik.values.taskAction === "Update Form"
  ? UpdateformOptions
  : [];

  return (
    <div className="">
      <Modal isOpen={isOpen} toggle={enhancedToggle} size="xl">
        <ModalHeader toggle={enhancedToggle} className="assign_blk p-0 mb-3">
        {isEdit ? "Edit Task" : "Add Tasks"}
        </ModalHeader>
          <Form onSubmit={formik.handleSubmit} className="form_schedule m-0 p-0">
            <ModalBody>
            {isLoading ? <Loader/> : null}
              <div className="schedule_task  modal_change_color p-4" style={{boxShadow:"none"}}>
                <Row>
                <Col lg={12}>
                      <TextInput
                          keyField={"title"}
                          label="Title"
                          required={true}
                          formik={formik}
                          type="text"
                          value={formik.values.title}
                          onChange={(e) =>
                            formik.setFieldValue("title", e.target.value)
                          }
                        />
                      </Col>
                </Row>
                  <Row className="">
                    <Col lg={4}>
                        <TextInput
                          keyField={"patientId"}
                          label="Patient"
                          required={true}
                          formik={formik}
                          options={patientList}
                          type="select"
                          placeholder="Select"
                          value={formik.values.patientId}
                          onChange={(e) => formik.setFieldValue("patientId", e.target.value)}
                        />
                    </Col>
                    <Col lg={4}>
                      <TextInput
                        keyField={"applicationId"}
                        label="Applications"
                        formik={formik}
                        required={true}
                        options={applicationList}
                        type="select"
                        placeholder="Select"
                        value={formik.values.applicationId}
                        onChange={(e) => formik.setFieldValue("applicationId", e.target.value)}
                        />
                    </Col>
                  <Col lg={4}>
                    <TextInput
                        keyField={"taskAction"}
                        label="Task Action"
                        options={taskActionOptions}
                        type="select"
                        required={false}
                        placeholder="Select"
                        value={formik.values.taskAction}
                        onChange={(e) =>
                          formik.setFieldValue("taskAction", e.target.value)
                        }
                      />
                    </Col>
                    {isDocumentListVisible && (
                    <Col lg={4}>
                    <TextInput
                        keyField={"documentId"}
                        label="Document"
                        options={UpdateDocumentOptions}
                        type="select"
                        required={false}
                        placeholder="Select"
                        value={formik.values.documentId}
                        onChange={(e) =>
                          formik.setFieldValue("documentId", e.target.value)
                        }
                      />
                    </Col>)}
                    {/* {isFormListVisible && (
                    <Col xs={12} sm={6} lg={4} className="">
                    <TextInput
                        keyField={"formId"}
                        label="Form"
                        required={false}
                        options={formOptions} // Replace with actual form options
                        type="select"
                        placeholder="Select"
                        value={formik.values.formId}
                        onChange={(e) =>
                          formik.setFieldValue("formId", e.target.value)
                        }
                      />
                    </Col>)} */}
                    {isFormListVisible && (
                      <Col lg={4}>
                        <TextInput
                          keyField={"formId"}
                          label="Form"
                          required={false}
                          options={selectedFormOptions} // Dynamically selected options
                          type="select"
                          placeholder="Select"
                          value={formik.values.formId}
                          onChange={(e) => formik.setFieldValue("formId", e.target.value)}
                        />
                      </Col>
                    )}

                    <Col lg={4}>
                      <TextInput
                          keyField={"assignTo"}
                          required={true}
                          label="Assign To"
                          formik={formik}
                          options={assignToList}
                          type="select"
                          placeholder="Select"
                          value={formik.values.assignTo}
                          onChange={(e) => formik.setFieldValue("assignTo", e.target.value)}
                          />
                    </Col>
                    <Col lg={4} className="modal_pro_file">
                      <DatePickerSelector
                          keyField={"dueDate"}
                          formik={formik}
                          required={false}
                          value={formik.values.dueDate}
                          minDate={moment().startOf('day').toDate()} // disables all past dates
                          maxDate={""}
                          label="Due Date"
                          type="date"
                          onChange={(e) =>
                            formik.setFieldValue("dueDate", moment(e).format("MM-DD-YYYY"))
                          }
                        />
                      </Col>
                  <Col lg={12}>
                    <TextInput
                        keyField={"notes"}
                        label="Notes"
                        formik={formik}
                        required={false}
                        type="text"
                        value={formik.values.notes}
                        onChange={(e) => formik.setFieldValue("notes", e.target.value)}
                      />
                      </Col>
                  </Row>
              </div>
            </ModalBody>
            <div className="d-flex gap-4 justify-content-center schedule_task shadow-none">
                    <Button className="primary" type="submit">Save</Button>
                    <Button className="secondary" type="button" onClick={()=>enhancedToggle()} >
                      Close
                    </Button>
            </div>
          </Form>
      </Modal>
    </div>
  );
};

export default AddTask;
